import {
  JOB_MAX_NAME_LENGTH,
  JOB_MAX_TITLE_LENGTH,
  JOB_MAX_DESCRIPTION_LENGTH,
  JOB_MAX_OCCUPATION_NAME_LENGTH,
  JOB_MAX_OCCUPATION_NOTE_LENGTH,
  JOB_MAX_HOLIDAY_NOTE_LENGTH,
  JOB_MAX_REQUIREMENT_NOTE_LENGTH,
  JOB_MAX_TREATMENT_NOTE_LENGTH,
  JOB_MAX_INSURANCE_LENGTH,
  JOB_MAX_CONTRACT_PERIOD_LENGTH,
  JOB_MAX_PASSIVE_SMOKING_LENGTH,
  JOB_MAX_SELECTION_NOTE_LENGTH,
  JOB_MAX_QUESTION_LENGTH,
  JOB_PHOTO_MAX_CAPTION_LENGTH,
  PHONE_RECEPTION_MAX_PHONE_NUMBER_LENGTH,
  PHONE_RECEPTION_MAX_RECEPTION_TIME_LENGTH,
  PHONE_RECEPTION_MAX_RECRUITER_NAME_LENGTH,
  PHONE_RECEPTION_MAX_JOB_NUMBER_LENGTH,
} from '../../../lib/constants.js.erb';

$(() => {
  const $form = $('.js-validate-form-job');

  $form.validate({
    rules: {
      'job[name]': {
        required: true,
        maxlength: JOB_MAX_NAME_LENGTH,
      },
      'job[title]': {
        maxlength: JOB_MAX_TITLE_LENGTH,
      },
      'job[description]': {
        required: true,
        maxlength: JOB_MAX_DESCRIPTION_LENGTH,
      },
      'job[occupation_id]': {
        required: true,
      },
      'job[occupation_name]': {
        required: true,
        maxlength: JOB_MAX_OCCUPATION_NAME_LENGTH,
      },
      'job[occupation_note]': {
        maxlength: JOB_MAX_OCCUPATION_NOTE_LENGTH,
      },
      'job[holiday_note]': {
        maxlength: JOB_MAX_HOLIDAY_NOTE_LENGTH,
      },
      'job[requirement_note]': {
        maxlength: JOB_MAX_REQUIREMENT_NOTE_LENGTH,
      },
      'job[treatment_note]': {
        maxlength: JOB_MAX_TREATMENT_NOTE_LENGTH,
      },
      'job[insurance]': {
        maxlength: JOB_MAX_INSURANCE_LENGTH,
      },
      'job[contract_period]': {
        maxlength: JOB_MAX_CONTRACT_PERIOD_LENGTH,
      },
      'job[passive_smoking]': {
        maxlength: JOB_MAX_PASSIVE_SMOKING_LENGTH,
      },
      'job[phone_reception_attributes][phone_number]': {
        required: true,
        maxlength: PHONE_RECEPTION_MAX_PHONE_NUMBER_LENGTH,
      },
      'job[phone_reception_attributes][reception_time]': {
        maxlength: PHONE_RECEPTION_MAX_RECEPTION_TIME_LENGTH,
      },
      'job[phone_reception_attributes][recruiter_name]': {
        maxlength: PHONE_RECEPTION_MAX_RECRUITER_NAME_LENGTH,
      },
      'job[phone_reception_attributes][job_number]': {
        maxlength: PHONE_RECEPTION_MAX_JOB_NUMBER_LENGTH,
      },
      'job[selection_note]': {
        maxlength: JOB_MAX_SELECTION_NOTE_LENGTH,
      },
      'job[question]': {
        maxlength: JOB_MAX_QUESTION_LENGTH,
      },
      'job[shop_id]': {
        required: true,
      },
      'job[job_photos_attributes][][caption]': {
        maxlength: JOB_PHOTO_MAX_CAPTION_LENGTH,
      },
    },
    errorPlacement(error, element) {
      error.insertAfter(element);
    },
  });
});
